import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { SidebarLinksMenu, SidebarLinksMenuLink } from '../Sidebar/SidebarLinksMenu/SidebarLinksMenu';

import './SidebarInfoMenu.css';
import * as keyset from './SidebarInfoMenu.i18n';

const i18n = i18nFactory(keyset);

export interface SidebarInfoMenuProps {
    manager: {
        name: string;
        tel?: string;
        email: string;
        representativeName?: string;
    };
    contacts: Array<
        | {
              name: string;
              tel?: string;
          }
        | undefined
    >;
    links: SidebarLinksMenuLink[];
}

export class SidebarInfoMenu extends React.Component<SidebarInfoMenuProps> {
    render() {
        const { links } = this.props;

        return (
            <div className={Bem.cls('sidebar-info-menu')}>
                <div className={Bem.cls('sidebar-info-menu', 'contacts')}>
                    {this.getManagerContacts()}

                    <div className={Bem.cls('sidebar-info-menu', 'contacts-title')}>{i18n('support-phone')}</div>

                    {this.getContacts()}
                </div>

                <SidebarLinksMenu links={links} />
            </div>
        );
    }

    private getManagerContacts() {
        const { manager } = this.props;

        if (!manager.name) {
            return null;
        }

        return (
            <>
                <div className={Bem.cls('sidebar-info-menu', 'contacts-title')}>{i18n('manager')}</div>
                <div className={Bem.cls('sidebar-info-menu', 'contacts-name')}>{manager.name}</div>
                <div className={Bem.cls('sidebar-info-menu', 'contacts-tel')}>{manager.tel}</div>
                <div className={Bem.cls('sidebar-info-menu', 'contacts-email')}>{manager.email}</div>
            </>
        );
    }

    private getContacts() {
        return this.props.contacts
            .filter(el => Boolean(el))
            .map((el: { name: string; tel?: string }) => (
                <div className={Bem.cls('sidebar-info-menu', 'support-contacts')}>
                    <div className={Bem.cls('sidebar-info-menu', 'support-contacts-city-name')}>{el.name}</div>
                    <div className={Bem.cls('sidebar-info-menu', 'support-contacts-tel')}>{el.tel}</div>
                </div>
            ));
    }
}
